// UK-format helpers — all booking display dates render as DD/MM/YYYY.
// Inputs accept both ISO strings ("2026-08-01") and Date objects.

const pad = (n) => String(n).padStart(2, '0');

// "2026-08-01" -> "01/08/2026". Returns the original string if unparseable.
export const formatUkDate = (value) => {
  if (!value) return '';
  if (value instanceof Date) {
    if (Number.isNaN(value.getTime())) return '';
    return `${pad(value.getDate())}/${pad(value.getMonth() + 1)}/${value.getFullYear()}`;
  }
  const s = String(value);
  const isoMatch = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (isoMatch) return `${isoMatch[3]}/${isoMatch[2]}/${isoMatch[1]}`;
  const d = new Date(s);
  if (Number.isNaN(d.getTime())) return s;
  return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()}`;
};

// "2026-08-01" + "14:30" -> "01/08/2026 at 14:30"
export const formatUkDateTime = (date, time) => {
  const d = formatUkDate(date);
  if (!d) return time || '';
  return time ? `${d} at ${time}` : d;
};
